import axios, { AxiosResponse } from "axios";
import { postRequest } from "@/Utils/Service/BackendService";
import { DismissBannnerFeedMessageRequest } from "@/Contracts";

const dismissBannerNotificationURL = "/v2/banners/dismiss";

export const dismissBannerNotification = async (
	banner: DismissBannnerFeedMessageRequest
): Promise<any> => {
	try {
		const response: AxiosResponse<any> = await axios(
			postRequest(
				dismissBannerNotificationURL,
				banner,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
